import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import Card from '../../components/grants/card';
import Dropdown from '../../components/dropdowns/dropdown';
import Pagination from './components/pagination';

import {Layout, SeventyThirtyLayout} from '../../layouts';
import {ApplyButton, ManageButton } from '../../components/buttons';
import GrantsApi from "../../lib/grants/grants-api";
import {nowTimeStamp, nowUTCTimeStamp, stringToFriendlyDatetime} from "../../lib/helpers/datetime-helpers";
import Sponsors from '../../components/sponsor';

import MediaQuery from 'react-responsive';

import ButtonPrevious from '../../components/buttons-navigation/button-previous';
import ButtonNext from '../../components/buttons-navigation/button-next';
import dayjs from "dayjs";
import GrantsUpcoming from "../grants-applications/components/grants-upcoming";

class UpcomingGrantsList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            grants : []
        };
    }


    componentDidMount() {
        this.getGrants();
    }

    getGrants() {
       const api = new GrantsApi();
       api.getGrants(1, 10, {available_from : nowTimeStamp()}).then(data => {
           this.setState({grants :  data.data});
       })
    }


    render() {

        if(this.state.grants.length === 0) {
            return (
                <div className="upcoming-grants">
                    <p className="section__title">Upcoming Grants</p>
                    {/*<p className="section__subtitle">Please Hover/Click to see more info</p>*/}
                    <div className="upcoming-grants__grants">
                        <div className="upcoming-grants__item upcoming-grants__item--empty">
                            <div className='upcoming-grants-item__text'><p>No upcoming grants scheduled</p></div></div>
                    </div>
                </div>
            )
        }

        return(
            <GrantsUpcoming
                title={'Upcoming Grants'}
                items={this.state.grants.map(item => {
                    return {
                        description : item.name,
                        id : `Available from ${stringToFriendlyDatetime(item.available_from)}`,
                        meta : item.funding_body
                    };
                })}
            />
        );


    }


}

class GrantsList extends Component{
    constructor(props) {
        super(props);

        this.state = {
            selectedGrant: 0,
            width: window.innerWidth,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    next() {
        this.setState({ selectedGrant: this.state.selectedGrant - 1 });
    }

    previous() {
        this.setState({ selectedGrant: this.state.selectedGrant + 1 });
    }

    renderApplications() {
        return this.props.grants.map(app => {
                return <Card
                    title={app.name}
                    subtitle={app.funding_body}
                    infos={[
                        {
                            label : 'OPENS',
                            value : stringToFriendlyDatetime(app.available_from)
                        },
                        {
                            label : 'CLOSES',
                            value : stringToFriendlyDatetime(app.available_to)
                        }
                    ]}
                    buttons={
                        <>
                            <ManageButton onClick={() => window.location.href = `/myeb/grants/view/${app.id}`}>Apply</ManageButton>
                        </>
                    }

                />
            });
    }

    renderContainer(translate) {
        const getNumItems = () => {
            return this.state.width <= 685 ? 1 : 2;
        }

        const max = this.state.selectedGrant - getNumItems();

        return (
            <>
                <div className="grants-list__inner" style={{ transform: `translateX(${this.state.selectedGrant * translate}%)` }}>
                    { this.renderApplications() }
                </div>
            </>
        )
    }

    renderCarouselButton() {
        const getNumItems = () => {
            return this.state.width <= 685 ? 1 : 2;
        }

        const max = this.state.selectedGrant - getNumItems();

        return (
            <div className="grants-list__buttons">
                { this.state.selectedGrant !== 0 && <ButtonPrevious onClick={this.previous.bind(this)}>Previous</ButtonPrevious> }
                { (-max < this.props.grants.length) && <ButtonNext onClick={this.next.bind(this)}>Next</ButtonNext> }
            </div>
        )
    }

    render() {
        return (
            <div className='grants-list'>
                <p className="section__title"><img src="/assets/logos/open-applications.svg"/> Grants</p>

                <div className="grants-list__content">
                    <MediaQuery minWidth="0px" maxWidth="685px">
                        { this.renderContainer(100) }
                    </MediaQuery>

                    <MediaQuery minWidth="686px" maxWidth="1279px">
                        { this.renderContainer(50) }
                    </MediaQuery>

                    <MediaQuery minWidth='1280px'>
                        <div className="grants-list__inner">
                            { this.renderApplications() }
                        </div>
                    </MediaQuery>
                </div>
                <MediaQuery minWidth="0px" maxWidth="685px">
                    { this.renderCarouselButton() }
                </MediaQuery>
                <MediaQuery minWidth="686px" maxWidth="1279px">
                    { this.renderCarouselButton() }
                </MediaQuery>
            </div>
        )
    }
}

function Welcome() {
    return (
        <div className="website-topbar__welcome">
            <p>Welcome to</p>
            <h3>Grants</h3>
        </div>
    )
}

class GrantsContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            grantId: null,
            grants: []
        };

        this.sectionOne = {
            name: 'Upcoming Grants',
            component: <UpcomingGrantsList/>
        }
    }

    componentDidMount() {
        new GrantsApi().getGrants(1, 100, {available : 1}).then(({data}) => {
            this.setState({grants: data});
        });
    }


    render() {
        return (
            <Layout topLeft={<Welcome/>}>
                <SeventyThirtyLayout main={<GrantsList grants={this.state.grants}/>} sectionOne={this.sectionOne}/>
                <Sponsors />
            </Layout>
        );
    }
}

const el = document.getElementById('grants');

if (el) {
    ReactDOM.render(<GrantsContainer/>, el);
}
